import zhUI from '@linktivity/link-ui/lang/zh';
import country from '@link/share/i18n/country/zh';

import japanPrefectures from '@link/share/i18n/japanPrefectures/zh';
import {
  NotificationType,
  PaymentType,
  PaymentPeriod,
  BookingType,
  IssuedStatus,
  CancelReason,
  ConfirmationType,
  DiscrepancyType,
  DiscrepancyReason,
  DiscrepancyStatus,
  DiscrepancyWaitingStatus,
  DiscrepancyInitiator,
  NotificationMethod,
  WalletOrderStatus,
  TransactionTypeMap
} from '@link/share/services/const';

export default {
  ...zhUI,
  country,
  japanPrefectures,
  common: {
    account: '帐户',
    signOut: '登出',
    status: '状态',
    action: '操作',
    parenthesis: '（{{text}}）',
    detail: '详细',
    edit: '编辑',
    add: '添加',
    save: '保存',
    or: '或者',
    delete: '删除',
    formTitle: '{{id}}（{{title}}）',
    withSpace: '{{val1}} {{val2}}',
    withDashSeparated: '{{val1}} - {{val2}}',
    withSlashSeparated: '{{val1}} × {{val2}}',
    withCommaSeparated: '{{val1}} / {{val2}}',
    slash: '/',
    confirm: '确定',
    editConfirm: '编辑确认',
    ON: '开启',
    OFF: '关闭',
    cancel: '取消',
    confirmDelete: '您确定要删除 {{name}} 吗？',
    yes: '是',
    no: '否',
    close: '关闭',
    has: '有',
    hasNot: '无',
    verify: '确认',
    register: '注册',
    continueEditing: '继续编辑',
    leaveCurrentPage: '离开此页面',
    leaveCurrentPageConfirm: '{{name}} 仍在编辑中。',
    separator: '，',
    pdf: 'PDF',
    mobile: '手机',
    rangeSymbol: '~',
    pc: 'PC',
    grossPrice: '售价金额',
    netPrice: '净金额',
    sender: '发件人',
    approver: '承认者',
    discrepancy: '差额调整内容',
    adjustmentAmount: '调整金额',
    commission: '佣金',
    cancelFee: '取消手续费',
    refundAmount: '退款金额',
    arrow: '→',
    colon: '：',
    empty: '暂无数据',
    viewDetail: '查看详情',
    voucher: '凭证',
    printableVoucher: '打印',
    forDisplayVoucher: '电子',
    supplier: '供应商',
    agent: '旅行社',
    complete: '完成',
    denied: '拒绝',
    downloadDetails: '下载明细',
    total: '搜索结果：{{total}} 条',
    infoSent: '信息已发送至{{target}}。',
    currency: '货币',
    zip: 'ZIP',
    excel: 'CSV',
    download: '下载',
    manual: '使用手册'
  },
  views: {
    contractsList: {
      title: '销售权限设置状况',
      supplier: '供应商（ID）',
      agent: '旅行社（ID）',
      systemChargePercent: '当前系统费率（%）',
      supplierCountry: '供应商（国家/地区）',
      agentCountry: '旅行社（国家/地区）'
    },
    contractDetail: {
      addTitle: '添加合同',
      editTitle: '编辑合同',
      title: '合同详情',
      form: {
        supplier: '供应商',
        agent: '旅行社',
        status: '状态',
        systemChargePercent: '当前系统费率（%）'
      }
    },
    suppliersList: {
      supplierCustomId: '供应商（ID）'
    },
    suppliersDetail: {
      title: '公司信息',
      supplierCustomId: '供应商 ID',
      originalName: '供应商名称',
      englishName: '供应商（英文名）',
      status: '状态',
      mainLanguage: '使用语言',
      salesAccounts: '业务负责人',
      webUrl: '官方网站',
      countryCode: '国家/地区',
      categories: '分类',
      registrationCode: '发票开具企业登记号',
      logoUrl: 'Logo',
      privacyPolicyType: '隐私政策处理',
      currency: '使用货币',
      transferFeePayer: '汇款手续费支付',
      billingMethod: '付款方式',
      systemFeeRefundPolicyCustomer: '系统使用费退款（客户取消）',
      systemFeeRefundPolicySupplier: '系统使用费退款（供应商取消）',
      systemFeeRefundPolicyInvalid: '系统使用费退款（无效化处理）'
    },
    suppliersAccount: {
      title: '账户管理',
      role: '权限',
      supplierCustomId: '供应商',
      loginId: '电子邮件',
      username: '用户名',
      supportLanguages: '使用语言'
    },
    suppliersAccountDetail: {
      addTitle: '添加帐户',
      editTitle: '账户编辑',
      supplierId: '供应商',
      loginId: '电子邮件地址（登录ID）',
      password: '密码',
      supportLanguages: '使用语言',
      role: '权限',
      notificationType: '通知类型',
      username: '用户名',
      phoneNumber: '电话号码',
      personInCharge: '负责人姓名',
      department: '部门/职位',
      receiveNotifications: '接收通知',
      notificationMethod: '通知接收方式',
      requireMfa: '两步验证'
    },
    newAgent: {
      otaCustomId: '旅行社 ID',
      title: '添加旅行社',
      originalName: '旅行社名称',
      englishName: '旅行社名称（英文名）',
      contractType: '已签署合同',
      mainLanguage: '主要语言',
      salesAccounts: '业务负责人',
      webUrl: '官方网址',
      country: '国家/地区',
      currency: '使用货币',
      logoUrl: 'Logo',
      paymentType: '支付方式',
      paymentPeriod: '结算周期'
    },
    agentAccountList: {
      role: '权限',
      org: '所属群组',
      loginId: '用户ID',
      username: '用户名',
      supportLanguages: '使用语言'
    },
    newAgentAccount: {
      title: '添加新帐户',
      otaId: '旅行社',
      otaOrgId: '所属群组',
      loginId: '电子邮件地址（登录ID）',
      password: '密码',
      role: '权限',
      supportLanguages: '使用语言',
      notificationType: '通知类型',
      username: '用户名',
      phoneNumber: '电话号码',
      personInCharge: '负责人姓名',
      department: '部门/职位',
      requireMfa: '两步验证'
    },
    orgList: {
      country: '国家/地区',
      parentOtaOrg: '上级群组',
      otaOrgName: '群组名称'
    },
    newOrg: {
      title: '添加群组',
      otaOrgCustomId: '群组 ID',
      otaOrgName: '群组名称',
      otaId: '旅行社',
      otaOrgId: '群组 ID',
      parentOtaOrgId: '上级群组',
      countryCode: '国家/地区',
      logoUrl: 'Logo',
      activityIdWhitelist: '商品销售设置'
    },
    login: {
      title: '欢迎来到GDS',
      email: '电子邮件',
      password: '密码',
      button: '登录',
      success: '已登录',
      link: '忘记密码请点击',
      resettitle: '密码重置',
      reset: '发送密码重置邮件',
      send: '已将密码重置链接发送至{{email}}，请查收邮件并重新设置密码。',
      resetError: '邮件发送失败，请稍后重试。',
      googleLogin: '使用 Google 账号登录',
      register: '新注册／联系我们请点击',
      privacy: '隐私政策',
      ipNotAllowed: '当前网络错误，请再尝试。'
    },
    enrollOTP: {
      title: '设置双重验证',
      description: '为了增强账户安全性，请使用认证应用扫描二维码',
      step1: '1. 在智能手机上安装 Google Authenticator',
      appStore: 'App Store (iOS)',
      googlePlay: 'Google Play (Android)',
      step2: '2. 扫描二维码',
      step3: '3. 输入显示的6位数字完成设置',
      qrLabel: '二维码',
      codeLabel: '认证应用的6位数字',
      submit: '确认并启用',
      enrollError: '验证码不正确，请重试'
    },
    verifyOTP: {
      title: '双重验证',
      code: '验证码',
      verify: '确认',
      verifyError: '验证码不正确，请重试'
    },
    changePassword: {
      title: '修改密码',
      oldPassword: '当前【密码】',
      newPassword: '新【密码】'
    },
    booking: {
      bookingCustomId: '预订编号',
      status: '状态',
      purchasedDate: '申请日',
      participationDate: '参加日',
      freeSale: '无库存限制',
      participationTime: '开始时间',
      activityTitleSupplierLang: '商品',
      planTitle: '方案',
      orderCount: '数量',
      firstName: '参加者姓名',
      participantResidentRegion: '参加者居住国家/地区',
      participantEmailAddress: '参加者电子邮件',
      destinationEmail: '联系信息',
      agentReservationNote: '旅行社预订编号',
      agentBookingIdRemark: '旅行社预订编号（备注）',
      agentReservationSpecialNote: '旅行社预订特别备注',
      supplierBookingId: '供应商预订编号',
      bookingDetail: '预订详情',
      bookingNumber: '预订编号',
      parentBookingNumber: '关联预订编号',
      bookingType: '购买类别',
      applicationDate: '申请日',
      bookingStatus: '预订状态',
      cancelledBySupplier: '由供应商操作',
      issuedStatus: '使用状态',
      bookerName: '预订代表人姓名',
      bookerEmail: '预订代表人邮件地址',
      product: '商品/套餐',
      productVoucherLang: '商品/套餐（预订语言）',
      voucherExpiration: '凭证有效期',
      paymentInfo: '付款信息',
      salePrice: '销售价格',
      commission: '手续费',
      netPrice: '批发价格',
      free: '无库存限制',
      individual: '单独',
      download: '下载',
      exchangeUrl: '兑换用URL',
      openUrl: '打开URL',
      discrepancies: '差额调整',
      cancelBooking: '取消预订',
      invalidBookingBtn: '预订无效',
      invalidBooking: '是否要使该预订无效？',
      invalidBookingConfirmP1: '是否要使所选预订无效？',
      invalidBookingConfirmP2: '此操作无法撤销，请在继续前确认内容。',
      invalidBookingConfirmP3: '作废后在账单中的反映方式，可在下一步进行选择。',
      invalidBookingConfirmText: '作废',
      invalidBookingConfirmProcessing: '当前为处理中预订，仍要作废吗？',
      invalidBookingSecondTitle: '请选择结算书的反映方式',
      invalidBookingOpt1Title: '1. 反映至预约确认日所属月份（或周）的结算书',
      invalidBookingOpt1P1:
        '本次预约将以全额退款形式，反映至预约确认日所属月份（或周）的结算书中。',
      invalidBookingOpt1P2:
        '若执行作废操作的日期已超过预约确认日所属月份（或周）的结算截止日，且结算书已发行，则该月份（或周）的结算书将被重新发行。',
      invalidBookingOpt1P3:
        '作废处理完成后，请务必重新下载并确认最新版本的结算书。',
      invalidBookingOpt1P4: '此外，本次预约信息',
      invalidBookingOpt1P5:
        '将不会显示在作废操作日期所属月份（或周）的结算书中。',
      invalidBookingOpt2Title:
        '2. 反映至执行作废操作日期所属月份（或周）的结算书',
      invalidBookingOpt2P1:
        '本次预约将以全额退款形式，反映至执行作废操作日期所属月份（或周）的结算书中。',
      invalidBookingOpt2P2:
        '即使执行作废操作的日期已超过预约确认日所属月份（或周）的结算截止日且结算书已发行，结算书也不会被重新发行。',
      cancelFeeAndRefundAmount: '取消手续费与退款金额',
      currentDateTime: '当前日期和时间',
      amount: '数量',
      paidAmount: '付款金额',
      cancelFee: '取消费用',
      refundAmount: '退款金额',
      confirmedBy: '确认人姓名',
      performCancel: '取消',
      cancelResult: '取消完成',
      cancelSucceed: '取消成功',
      cancelPending: '取消处理中，等待供应商回复。',
      unitAdditionalLabel: '{{unitTitle}}{{unitIndex}}的附加预订信息',
      cancelReason: '取消原因',
      cancelComment: '取消备注',
      denyReason: '拒绝原因',
      name: '{{firstName}} {{lastName}}',
      otaName: '销售方名称',
      endUserRefundAmount: '终端用户退款金额',
      paymentRefundAmount: '退款金额',
      cancelFeeFromTravelerToAgent: '取消手续费（旅客至代理商）',
      cancelFeeFromAgentToLink: '取消手续费（代理商至LINKTIVITY）',
      finalSettlementToLink: '最终结算金额（至LINKTIVITY）',
      paymentRefundAmountOta: '退款金额（代理商）',
      cancelFeeFromLinkToSupplier: '取消手续费（LINKTIVITY至供应商）',
      systemCharge: '系统费用',
      finalSettlementFromLink: '最终结算金额（来自LINKTIVITY）',
      linkCancelFee: '取消手续费（LINKTIVITY回收部分）',
      linkRevenue: 'LINKTIVITY收益'
    },
    discrepancies: {
      title: '差额调整申请{{type}}',
      finished: '已发送',
      return: '返回预订详情',
      send: '发送',
      receive: '接收',
      discrepancy: '差额调整',
      discrepancyType: '调整内容',
      reasonDescription: '详情',
      reason: '原因',
      priceAdjust: '调整金额（差额）',
      grossAdjustmentAmount: '销售价格',
      netAdjustmentAmount: '批发价格',
      addItem: '新增项目',
      bookingInfo: '预订信息',
      adjustmentItem: '调整项目',
      verifier: '确认人姓名',
      applicant: '申请人',
      enterName: '请输入姓名',
      apply: '提交申请',
      adjustmentAmount: '调整金额',
      originalGrossAmount: '原销售价格',
      originalNetAmount: '原批发价格',
      adjustedGrossAmount: '调整后的销售价格',
      adjustedNetAmount: '调整后的批发价格',
      requiredAmount: '请输入金额',
      applySuccessTitle: '已发送差额调整申请',
      approveSuccessTitle: '已批准差额调整申请',
      denySuccessTitle: '已拒绝差额调整申请',
      successMsg: '已批准的调整金额将反映在最近的支付月份。',
      alert: '确认后，输入的差额调整项目将发送至{{target}}进行审批。',
      waitingTip: '已将以下调整项目发送至{{target}}，当前等待{{target}}审批。',
      reviewTip: '是否批准以下差额调整项目？',
      approve: '批准',
      deny: '拒绝'
    },
    bookingList: {
      title: '预订管理',
      filter: {
        bookingCustomId: '预订编号',
        activityTitle: '商品名',
        planTitle: '方案名',
        status: '状态',
        participantName: '预订代表人姓名',
        participantEmail: '预订代表人邮件地址',
        purchasedAtStart: '申请日',
        participateDateStart: '参加日期（本地产品）',
        agentReservationNo: '旅行社的预订号码',
        supplierBookingId: '供应商的预订号码'
      },
      participantResidentRegion: '国家/地区',
      refreshIssuedStatus: '刷新使用状态',
      refreshIssuedStatusSuccess:
        '使用状态已刷新（对象：{{matched}}件，成功：{{refreshed}}件，跳过：{{skipped}}件，失败：{{failed}}件）'
    },
    bulkBookingList: {
      title: '预订管理',
      reservationNumber: '预订编号',
      status: '状态',
      submitDate: '提交日',
      product: '商品',
      plan: '方案',
      agent: '旅行社'
    },
    discrepancyList: {
      title: '差额调整',
      purchaseDate: '购买日',
      participationDate: '参加日',
      keyword: '关键词',
      activity: '商品',
      plan: '方案',
      reservationNumber: '预订编号',
      transactionType: '交易类型',
      adjustmentStatus: '调整状态',
      salesPrice: '销售价格',
      wholesalePrice: '批发价格',
      sender: '发件人',
      senderFormat: '{{senderName}} ({{initiator}})'
    },
    notificationInbox: {
      title: '通知列表',
      all: '全部 ({{count}})',
      summary: '共 {{total}} 条 · 未读 {{unread}} 条',
      empty: '暂无通知',
      detailPlaceholder: '请在左侧选择通知以查看详情。',
      detailLoadError: '获取通知详情失败'
    },
    invoiceChange: {
      title: '金额调整',
      adjustmentDate: '调整日期',
      adjustedBy: '调整者',
      invoiceAmount: '请款金额',
      adjustmentAmount: '调整金额',
      paymentAmount: '付款金额',
      adjustmentReason: '调整原因',
      submit: '确认',
      addFile: '上传文件',
      historyTitle: '金额调整历史记录',
      finalAmount: '调整后的付款金额'
    }
  },
  const: {
    cancelErrorCode: {
      BOOKING_NOT_FOUND: '未找到该预订',
      BOOKING_ALREADY_CANCELLED: '已取消',
      CANCEL_DEADLINE_PASSED: '已超过取消期限',
      BOOKING_ALREADY_ISSUED: '此预订已出票，不可取消',
      BOOKING_STATUS_NOT_CANCELLABLE: '此预订在当前状态下不可取消',
      BOOKING_INVALIDATION_IN_PROGRESS: '此预订正在无效化处理中，不可取消',
      BOOKING_DECLINE_INSTEAD_OF_CANCEL: '此预订需以拒绝处理而非取消',
      BOOKING_NOT_CANCELLABLE: '此预订不可取消',
      CANCEL_NOT_STARTED: '取消流程尚未开始',
      CANCEL_REFUND_CHANGED: '取消费或退款金额已变更',
      BOOKING_ADAPTER_BOOKING_NOT_CANCELLABLE: '供应商拒绝了取消',
      BOOKING_ADAPTER_EXTERNAL_FAILED: '供应商拒绝了取消',
      BOOKING_ADAPTER_EXTERNAL_PENDING: '正在等待供应商确认，请稍后重试',
      RETRYABLE: '请稍后重试',
      UNKNOWN: '此预订不可取消'
    },
    cancelDeadline: '取消期限：{{deadline}}',
    language: {
      JAPANESE: '日文',
      ENGLISH: '英文',
      CHINESE: '中文（简体）',
      CHINESE_T: '中文（繁体）',
      KOREAN: '韩文'
    },
    partnerCategory: {
      RAILWAY: '铁路',
      BUS: '巴士',
      FERRIES: '渡轮',
      RENTAL_CAR: '租车',
      SIGHTSEEING_SPOT: '观光景点',
      FOOD: '餐厅',
      EXPERIENCE: '体验',
      ACCOMMODATION: '酒店',
      TOUR: '行程',
      ACTIVITY: '活动',
      CHARTER: '包车',
      LINKTIVITY: 'LINKTIVITY',
      OTHERS: '其他'
    },
    privacyPolicyType: {
      EMAIL_NOT_SHOW: '隐藏客户邮箱',
      NAME_NOT_SHOW: '隐藏客户姓名',
      REGISTERED_CODE_NOT_SHOW: '隐藏预订编号',
      OTA_BOOKING_ID_NOT_SHOW: '隐藏旅行社预订编号',
      SUPPLIER_BOOKING_ID_NOT_SHOW: '隐藏催行公司预订编号'
    },
    transferFeePayer: {
      LINK: 'LINKTIVITY',
      SUPPLIER: '供应商'
    },
    billingMethod: {
      PURCHASE_DATE: '购买日',
      USAGE_DATE: '使用日'
    },
    systemFeeRefundPolicy: {
      NO_REFUND: '不退款',
      ALL_REFUND: '全额退款'
    },
    role: {
      ADMIN: '管理员',
      VIEWER: '查看者',
      EDITOR: '编辑者',
      OPERATOR: '操作员'
    },
    contractType: {
      equivalent: 'TERM_OF_SERVICE_V20181101 等效项',
      nonEquivalent: 'TERM_OF_SERVICE_V20181101 非等效'
    },
    checklistType: {
      RESTRICTION: '参加限制',
      REQUIRED_ITEM_TO_BRING_AND_ATTIRE: '需要携带的衣物和物品',
      REQUIRED_OTHER: '参与所需的其他事项',
      REQUIRED_ADDITIONAL_NOTE: '备注/其他',
      NICE_TO_HAVE_ITEM_TO_BRING_AND_ATTIRE: '建议携带的衣物和物品',
      NICE_TO_HAVE_OTHER: '其他建议',
      INCLUDED: '包含内容'
    },
    notificationType: {
      [NotificationType.NoNotification]: '无通知',
      [NotificationType.ActivityOperation]: '商品相关',
      [NotificationType.BookOperation]: '预约相关',
      [NotificationType.FinanceOperation]: '结算・财务相关',
      [NotificationType.SystemOperation]: '来自LINK的通知'
    },
    inboxCategory: {
      [NotificationType.ActivityOperation]: '商品相关',
      [NotificationType.BookOperation]: '预约相关',
      [NotificationType.FinanceOperation]: '结算・财务相关',
      [NotificationType.SystemOperation]: '来自LINK的通知',
      [NotificationType.UndefinedNotification]: '其他',
      [NotificationType.NoNotification]: '无'
    },
    notificationMethod: {
      [NotificationMethod.UndefinedMethod]: '未定义',
      [NotificationMethod.Email]: '电子邮件',
      [NotificationMethod.InternalMessage]: '站内信'
    },
    paymentType: {
      [PaymentType.PostBankTransfer]: '后付（银行转账）',
      [PaymentType.PreLinkpay]: '在线支付（预付款）',
      [PaymentType.PostLinkpay]: '后付（LinkPay）',
      [PaymentType.PreCharge]: '银行转账（预付款）'
    },
    paymentPeriod: {
      [PaymentPeriod.Weekly]: '周',
      [PaymentPeriod.Monthly]: '月',
      [PaymentPeriod.HalfMonthly]: '双周'
    },
    attachmentType: {
      PDF: 'PDF',
      IMAGE: '图片'
    },
    bookingField: {
      PARTICIPANT_EMAIL_ADDRESS: '参加者电子邮件',
      HOTEL_NAME: '住宿名称',
      HOTEL_ADDRESS: '住宿地址',
      HOTEL_RESERVATION_LAST_NAME: '住宿代表人姓名（姓）',
      HOTEL_RESERVATION_FIRST_NAME: '住宿代表人姓名（名）',
      HOTEL_TEL: '住宿电话号码',
      ARRIVAL_DATE: '当地抵达日',
      ARRIVAL_TIME: '抵达时间',
      ARRIVAL_FLIGHT_NUMBER: '航班到达班次',
      DEPARTURE_DATE: '出发日',
      DEPARTURE_TIME: '出发时间',
      DEPARTURE_FLIGHT_NUMBER: '航班出发班次',
      DESTINATION_EMAIL: '当地联系方式（邮箱）',
      DESTINATION_TEL: '当地联系方式（电话号码）',
      PARTICIPANT_RESIDENT_REGION: '参加者居住国家/地区',
      PARTICIPANT_LANGUAGE: '参加者语言'
    },
    extendedBookingField: {
      PASSENGERS_QUANTITY: '乘车人数',
      PREFERRED_START_TIME: '希望开始时间',
      PREFERRED_PICK_UP_LOCATION: '接送／上车地点',
      PREFERRED_DROP_OFF_LOCATION: '送达／下车地点',
      PARTICIPANTS_QUANTITY: '参加人数',
      LUGGAGE_QUANTITY: '行李箱数量（合计）',
      CHILDREN_WITHOUT_SEAT_QUANTITY: '不需要座椅的婴儿',
      CHILD_SEAT_QUANTITY_PAID: '是否使用儿童座椅 ※现场支付',
      CHILD_SEAT_QUANTITY_FREE: '是否使用儿童座椅 ※免费',
      PREFERRED_GUIDE_LANGUAGE_CODE: '希望导览语言',
      PREFERRED_DRIVER_LANGUAGE_CODE: '希望司机使用的语言'
    },
    extendedParticipantField: {
      PASSPORT_FIRST_NAME: '参加者名字（护照拼音）',
      PASSPORT_LAST_NAME: '参加者姓氏（护照拼音）',
      PASSPORT_NATIONALITY: '国籍',
      PASSPORT_NUMBER: '护照号码',
      DATE_OF_BIRTH: '出生日期',
      AGE: '年龄',
      GENDER: '性别',
      EYESIGHT: '视力',
      WEIGHT_KG: '体重（kg）',
      HEIGHT_CM: '身高（cm）',
      SHOE_SIZE_CM: '鞋码（cm）',
      CLOTHES_SIZE: '服装尺寸',
      VEGETARIAN_MEALS: '素食需求',
      DIVING_EXPERIENCE_TIMES: '潜水经验次数',
      RENTAL_EQUIPMENTS_FREE: '是否需要器材租赁 ※免费',
      RENTAL_EQUIPMENTS_PAY_LOCALLY: '是否需要器材租赁 ※现场支付'
    },
    bookingStatus: {
      REQUEST_PENDING: '需求',
      REQUEST_REJECTED: '已拒绝',
      CONFIRMED: '已确认',
      CANCELLED_BY_TRAVELER: '取消（客户）',
      CANCELLED_BY_SUPPLIER: '取消（供应商）',
      INVALID: '作废',
      CANCEL_FAILED: '取消失败',
      CANCEL_PENDING: '取消保留中'
    },
    bulkBookingStatus: {
      SUBMITTED: '已提交',
      PAID: '已汇款',
      ACCEPTED: '已批准',
      QUEUED: '待发出',
      ISSUED: '已发出',
      PENDING: '待处理'
    },
    bulkBookingAction: {
      SUBMIT: '提交',
      PAY: '汇款',
      ACCEPT: '审批',
      PEND: '保留',
      ISSUE: '出票',
      FINISH: '完成'
    },
    confirmationType: {
      [ConfirmationType.FreeSale]: '指定参加日（无库存限制）',
      [ConfirmationType.FreeSaleOpenDate]: '无需指定参加日（无库存限制）',
      [ConfirmationType.Inventory]: '请指定参与日期（实时）',
      [ConfirmationType.Request]: '请指定您希望参加的日期（申请）。'
    },
    // use for bookingDetail page
    bookingConfirmationType: {
      [ConfirmationType.FreeSale]: '无库存限制',
      [ConfirmationType.FreeSaleOpenDate]: '无库存限制',
      [ConfirmationType.Inventory]: '即时预订',
      [ConfirmationType.Request]: '非即时预订'
    },
    walletOrderStatus: {
      [WalletOrderStatus.StatusPending]: '未付款',
      [WalletOrderStatus.StatusPaying]: '充值未完成',
      [WalletOrderStatus.StatusPaid]: '汇款完成',
      [WalletOrderStatus.StatusRejected]: '已拒绝',
      [WalletOrderStatus.StatusCancelled]: '已取消',
      [WalletOrderStatus.StatusConfirmed]: '充值完成',
      [WalletOrderStatus.StatusRefunded]: '已退款'
    },
    transactionTypeMap: {
      [TransactionTypeMap.TransactionTypeCancelRefund]: '已取消',
      [TransactionTypeMap.TransactionTypePurchase]: '已确认',
      [TransactionTypeMap.TransactionTypeDiscrepancy]: '差额已调整',
      [TransactionTypeMap.TransactionTypeInvalid]: '已失效'
    },
    discrepancyStatus: {
      [DiscrepancyStatus.Waiting]: '待审批',
      [DiscrepancyStatus.Approved]: '调整完成',
      [DiscrepancyStatus.Rejected]: '已驳回'
    },
    discrepancyWaitingStatus: {
      [DiscrepancyWaitingStatus.Deliver]: '待审批',
      [DiscrepancyWaitingStatus.Receive]: '待处理审批'
    },
    discrepancyInitiator: {
      [DiscrepancyInitiator.Ota]: '旅行社',
      [DiscrepancyInitiator.Supplier]: '供应商'
    },
    discrepancyType: {
      [DiscrepancyType.Refund]: '退款',
      [DiscrepancyType.AdditionalCharge]: '追加收费'
    },
    discrepancyReason: {
      [DiscrepancyReason.AdditionalServices]: '商品追加费用',
      [DiscrepancyReason.MissedServices]: '因未提供服务退款',
      [DiscrepancyReason.CustomerComplaint]: '因投诉退款',
      [DiscrepancyReason.DoubleCharge]: '重复请款',
      [DiscrepancyReason.FeeForBookingChange]: '变更手续费',
      [DiscrepancyReason.PartialCancel]: '部分取消',
      [DiscrepancyReason.SelfAdjustment]: '单独调整',
      [DiscrepancyReason.Other]: '其他'
    },
    bookingType: {
      [BookingType.Bulk]: '批量处理',
      [BookingType.Single]: '单独处理'
    },
    issuedStatus: {
      [IssuedStatus.Issued]: '已使用',
      [IssuedStatus.NotIssued]: '未使用',
      [IssuedStatus.Partial]: '部分使用',
      [IssuedStatus.Disable]: '无效'
    },
    cancelReason: {
      [CancelReason.BadWeather]: '恶劣天气',
      [CancelReason.BookedByMistake]: '误订',
      [CancelReason.DoubleBooking]: '重复预订',
      [CancelReason.FlightIssues]: '航班取消／延误／变更',
      [CancelReason.FoundCheaperRate]: '找到更便宜价格',
      [CancelReason.Other]: '其他',
      [CancelReason.ParticipantMinimumNotMet]: '未达最少成团人数',
      [CancelReason.ParticipantOrDateChange]: '更改预订日期或人数',
      [CancelReason.PrivateBuyout]: '团体包场／满员',
      [CancelReason.SameSupplierActivityChange]: '更改为同一供应商商品',
      [CancelReason.SeparateSupplierActivityChange]: '更改为其他供应商商品',
      [CancelReason.Sickness]: '身体不适',
      [CancelReason.OtaCancelWithoutReason]: 'OTA原因取消',
      [CancelReason.TechnicalDifficulties]: '设备故障或突发问题'
    },
    category: {
      RAILWAY_TICKET: '铁路车票',
      AIRPORT_TRANSPORTATION: '机场交通',
      SHINKANSEN: '新干线',
      EXPRESS_BUS: '高速巴士',
      BUS_TOUR: '巴士行程',
      CRUISES: '渡轮・邮轮',
      RENTAL_CAR: '租车',
      CHARTER: '包车',
      ATTRACTION: '设施（入场券）',
      THEME_PARK: '主题乐园',
      MUSEUM_GALLERY: '博物馆・美术馆',
      AQUARIUM_ZOO: '水族馆・动物园',
      TEMPLES_SHINES: '寺庙・神社・佛寺',
      TOWER_BUILDING: '观景台・塔',
      JAPANESE_RESTAURANT: '日式餐厅',
      WESTERN_RESTAURANT: '西式餐厅',
      CHINESE_RESTAURANT: '中式餐厅',
      OTHER_RESTAURANT: '餐厅（其他）',
      DESSERT_BEVERAGE: '甜点・饮品',
      SIGHTSEEING_TOUR: '观光行程',
      MARINE_SPORTS: '海上运动',
      OUTDOOR_ACTIVITIES: '户外活动',
      ONSEN: '温泉',
      SPA_MASSAGE: '水疗・按摩',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化体验',
      JAPANESE_CRAFT_EXPERIENCE: '日本工艺体验',
      JAPANESE_COOKING_EXPERIENCE: '和食制作体验',
      OTHER_EXPERIENCE: '其他体验',
      HOTEL: '酒店',
      RYOKAN: '旅馆',
      VACATION_RENTAL: '民宿',
      BUNDLE: '套票',
      PASS: '通票',
      OTHERS: '其他'
    },
    possibleIntervalShow: {
      DAY: '{{amount}}日内',
      MONTH: '{{amount}}个月内'
    },
    voucherExpirationFromPurchase: {
      DAY: '自购买日起{{time}}日内',
      MONTH: '自购买日起{{time}}个月内',
      SAME_DAY: '购买日当日'
    },
    voucherExpirationFromActivity: {
      DAY: '自参加日起{{time}}日内',
      MONTH: '自参加日起{{time}}个月内',
      SAME_DAY: '参加日当日'
    }
  },
  week: {
    SUNDAY: '日',
    MONDAY: '一',
    TUESDAY: '二',
    WEDNESDAY: '三',
    THURSDAY: '四',
    FRIDAY: '五',
    SATURDAY: '六'
  },
  bankInfo: {
    swiftCode: 'SWIFT代码',
    bankName: '银行名称',
    bankCode: '银行账户',
    bankBranchCode: '分行代码',
    bankBranchName: '分行名称',
    bankAddress: '银行地址',
    bankAccountNumber: '账户',
    accountHolderName: '账户名'
  },
  validation: {
    required: '{{name}}为必填项',
    invalid: '请输入有效的{{name}}',
    password: '请使用半角英数字和符号组合，至少8个字符',
    imageType: '请选择图片',
    fileSize: '请选择不超过{{size}}MB的文件',
    range: '{{name}}请输入{{min}}～{{max}}范围内的值',
    greaterThan: '{{name}}请输入大于{{min}}的值',
    notEqual: '{{name}}不能输入{{value}}',
    integer: '{{name}}请输入整数',
    requiredSelect: '请选择',
    alphabet: '请输入半角英文字母（可含空格，不可含数字）',
    otaCustomIdFormat: '请输入1~16位大写字母、数字或下划线，且以字母或数字开头',
    maxLength: '{{name}}请输入{{max}}个字符以内',
    personName: "{{name}}不能包含数字或特殊符号（可使用 ' - .）",
    telFormat: '请仅使用数字、「+」、「-」，且长度为8~20位',
    flightNumber: '请输入3~8位半角英数字，且需同时包含字母与数字',
    dateNotBefore: '{{name}}请输入{{min}}或之后的日期',
    dateNotAfter: '{{name}}请输入{{max}}或之前的日期',
    passportName: "请按护照记载的罗马字输入（仅半角英文字母、空格及 ' - .）",
    passportNumber: '请输入6~12位半角英数字',
    ageMismatch: '与根据出生日期计算的年龄（{{age}}岁）不一致'
  },
  messages: {
    newSuccess: '已添加',
    updateSuccess: '已更新',
    deleteSuccess: '已删除',
    copySuccess: '已复制',
    updateFailed: '更新失败',
    dateMax3Months: '日期范围请设定在3个月以内',
    downloadSuccess: '下载完成'
  },
  confirmDelete: {
    title: '请确认',
    prompt: '是否确认删除？'
  },
  autoLogout: {
    title: '即将自动退出登录',
    description1: '为了安全，9小时未操作将自动退出登录。',
    description2: '如需继续使用，请点击「继续」。',
    logout: '立即退出',
    continue: '继续'
  },
  firebase: {
    'auth/invalid-credential': '登录名或密码不正确。',
    'auth/email-already-in-use': '该邮箱已被注册。',
    'auth/too-many-requests': '登录尝试次数已超过上限，请稍后再试或重置密码。'
  },
  wallet: {
    feeRate: '手续费率',
    fee: '手续费',
    deductAmount: '合计金额',
    proceedToPayment: '同意并前往支付',
    invalidAmount: '请输入正确的金额'
  },
  transaction: {
    csvApplyDateTimezoneNote:
      '※注意：结算明细CSV的申请日期采用的是供应商设置的商品时区时间，而非旅行代理店的本地（浏览器）时间。'
  },
  activityDetail: {
    title: '商品详情',
    planTitle: '方案详情',
    faq: 'FAQ',
    location: '{{country}}',
    city: '・{{city}}',
    activity: {
      content: '商品内容',
      api: 'API Code',
      cancelPolicy: '取消政策',
      productId: '商品ID',
      operator: '供应商',
      timezone: '时区',
      currency: '货币',
      language: '翻译语言',
      category: '分类',
      departure: '出发地',
      destination: '目的地',
      activityId: '活动ID',
      activityName: '活动名称',
      planId: '方案ID',
      planName: '方案名称',
      planStartTimeId: '方案开始时间ID',
      planStartTimeName: '方案开始时间名称',
      startTime: '开始时间',
      planUnitItemsId: '方案单位项目ID',
      planUnitName: '方案单位名称'
    },
    plans: {
      description: '预订信息',
      notes: '注意事项',
      schedule: '行程',
      locations: '地点',
      additionalBookingInfo: '附加预订信息',
      startTime: '开始时间',
      noTimeLimit: '无限制',
      availableCount: '可预订数量',
      availableCountShow: '{{min}} ~ {{max}}',
      availablePeriod: '公开期间',
      availablePeriodShow:
        '{{startY}}-{{startM}}-{{startD}} ~ {{endY}}-{{endM}}-{{endD}}',
      possibleInterval: '可预订期间',
      reservationDeadline: '预订截止时间',
      reservationDeadlineShow: '请于参加日前{{day}}天的{{time}}前完成预订。',
      reservationDeadlineShowToday: '请于当日{{time}}前完成预订。',
      voucherExpiration: '凭证有效期',
      voucherExpirationAnnualCutOff:
        '年度基准日：{{annualFixedDate}}之前购买的订单将在当年相对日期：{{annualCutOffDate}}失效；年度基准日：{{annualFixedDate}}之后购买的订单将在次年相对日期：{{annualCutOffDate}}失效',
      optionalBookingFields: '代表人信息（选填）',
      optionalExtendedBookingFields: '其他信息（选填）',
      optionalParticipantFields: '参加者信息※每位参加者（选填）',
      requiredBookingFields: '代表人信息（必填）',
      requiredExtendedBookingFields: '其他信息（必填）',
      requiredParticipantFields: '参加者信息※每位参加者（必填）',
      customFields: '自定义预订信息',
      customFieldsShow: '{{title}} : {{des}}',
      meetingPlace: '集合地点',
      dismissalPlace: '解散地点',
      pickupPlace: '接送地点',
      dropOffPlace: '送达地点'
    }
  }
};
